/* SWICH · comportamiento del tema Apple */
(function () {
  /* 1. Aparición suave */
  function reveal() {
    var els = document.querySelectorAll('.ap-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Carrusel de reseñas */
  function carousels() {
    document.querySelectorAll('[data-ap-carousel]').forEach(function (c) {
      if (c.__ap) return; c.__ap = true;
      var track = c.querySelector('.ap-reviews__track');
      var prev = c.querySelector('[data-prev]'), next = c.querySelector('[data-next]');
      if (!track) return;
      function step() { var card = track.querySelector('.ap-review'); return card ? card.getBoundingClientRect().width + 16 : 320; }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* 3. Precios en formato chileno: $49,990 -> $49.990 (solo visual) */
  var RE = /\$\s?\d{1,3}(?:,\d{3})+/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };
  function fixPrices(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        RE.lastIndex = 0;
        return RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    nodes.forEach(function (t) { RE.lastIndex = 0; t.nodeValue = t.nodeValue.replace(RE, function (m) { return m.replace(/,/g, '.'); }); });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fixPrices(document.body); }); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });


  /* 4. Galería a pantalla completa con zoom suave (clic para acercar un poco, arrastrar para mover) */
  function initLightbox() {
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap || wrap.__apLb) return; wrap.__apLb = true;
    var lb, imgEl, stage, items = [], idx = 0, zoomed = false, scale = 1.5, tx = 0, ty = 0, lastFocus = null;

    function big(im) {
      var s = im.currentSrc || im.src;
      try { var u = new URL(s, location.href); u.searchParams.set('width', '2400'); u.searchParams.delete('height'); return u.toString(); } catch (e) { return s; }
    }
    /* Solo fotos: los videos y modelos 3D usan el reproductor propio de Shopify */
    function isPhoto(li) {
      return !!li.querySelector('img') && !li.classList.contains('ap-vhide') && !li.querySelector('.media-type-video, .media-type-external_video, .media-type-model, deferred-media, product-model');
    }
    function collect() {
      items = [].slice.call(wrap.querySelectorAll('.product__media-item')).filter(isPhoto);
    }
    function build() {
      lb = document.createElement('div');
      lb.className = 'ap-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Galería de imágenes');
      lb.innerHTML = '<div class="ap-lb__stage"><img class="ap-lb__img" alt="" draggable="false"></div>' +
        '<div class="ap-lb__ctrl">' +
        '<button type="button" class="ap-lb__btn" data-prev aria-label="Anterior"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
        '<button type="button" class="ap-lb__btn ap-lb__btn--close" data-close aria-label="Cerrar"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg></button>' +
        '<button type="button" class="ap-lb__btn" data-next aria-label="Siguiente"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' +
        '</div>';
      document.body.appendChild(lb);
      imgEl = lb.querySelector('.ap-lb__img'); stage = lb.querySelector('.ap-lb__stage');
      lb.querySelector('[data-close]').addEventListener('click', close);
      lb.querySelector('[data-prev]').addEventListener('click', function () { go(-1); });
      lb.querySelector('[data-next]').addEventListener('click', function () { go(1); });
      pointer();
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
      });
    }
    function apply() {
      imgEl.style.transform = zoomed ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')' : 'none';
      lb.classList.toggle('is-zoomed', zoomed);
    }
    function clamp() {
      var w = imgEl.offsetWidth * scale, h = imgEl.offsetHeight * scale;
      var mx = Math.max(0, (w - stage.clientWidth) / 2), my = Math.max(0, (h - stage.clientHeight) / 2);
      tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
    }
    function zoomAt(cx, cy) {
      if (zoomed) { zoomed = false; tx = ty = 0; apply(); return; }
      var r = stage.getBoundingClientRect();
      var px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2);
      zoomed = true; tx = -px * (scale - 1); ty = -py * (scale - 1); clamp(); apply();
    }
    function pointer() {
      var down = false, sx = 0, sy = 0, ox = 0, oy = 0, moved = 0;
      stage.addEventListener('pointerdown', function (e) {
        down = true; moved = 0; sx = e.clientX; sy = e.clientY; ox = tx; oy = ty;
        try { stage.setPointerCapture(e.pointerId); } catch (x) {}
        if (zoomed) lb.classList.add('is-drag');
      });
      stage.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx, dy = e.clientY - sy; moved = Math.max(moved, Math.abs(dx), Math.abs(dy));
        if (zoomed) { tx = ox + dx; ty = oy + dy; clamp(); apply(); }
      });
      function end(e) {
        if (!down) return; down = false; lb.classList.remove('is-drag');
        var dx = e.clientX - sx;
        if (moved < 6) { zoomAt(e.clientX, e.clientY); }
        else if (!zoomed && Math.abs(dx) > 60) { go(dx < 0 ? 1 : -1); }
      }
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', function () { down = false; lb.classList.remove('is-drag'); });
    }
    function show(i) {
      idx = (i + items.length) % items.length;
      zoomed = false; tx = ty = 0; apply();
      var im = items[idx].querySelector('img');
      imgEl.src = big(im); imgEl.alt = im.alt || '';
    }
    function go(d) { show(idx + d); }
    function open(i) {
      collect(); if (!items.length) return;
      if (!lb) build();
      lastFocus = document.activeElement;
      show(i); lb.classList.add('is-open'); document.documentElement.classList.add('ap-lb-lock');
      lb.querySelector('[data-close]').focus({ preventScroll: true });
    }
    function close() {
      lb.classList.remove('is-open'); document.documentElement.classList.remove('ap-lb-lock');
      zoomed = false; apply(); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('.slider-button, .thumbnail, .slider-buttons')) return;
      var li = e.target.closest('.product__media-item');
      if (!li || !isPhoto(li)) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      collect(); open(items.indexOf(li));
    }, true);
  }

  /* 4b. Videos de la galería: al tocarlos se abren y empiezan a reproducirse de inmediato */
  if (!window.__apVideoPlay) {
    window.__apVideoPlay = true;
    document.addEventListener('click', function (e) {
      var op = e.target.closest && e.target.closest('.product__media-wrapper modal-opener');
      if (!op || !op.closest('.product__media-item') || !op.closest('.product__media-item').querySelector('.media-type-video, .media-type-external_video')) return;
      var tries = 0;
      (function play() {
        var modal = document.querySelector(op.getAttribute('data-modal'));
        var media = modal && modal.hasAttribute('open') && modal.querySelector('deferred-media.active');
        if (!media) { if (++tries < 20) setTimeout(play, 50); return; }
        if (!media.hasAttribute('loaded') && media.loadContent) media.loadContent(false);
        var v = media.querySelector('video');
        if (!v) return;
        /* El tema pausa todo el contenido al abrir el modal: reintenta hasta que arranque */
        [0, 250, 600, 1200].forEach(function (ms) {
          setTimeout(function () {
            if (v.paused && v.currentTime < 0.3 && modal.hasAttribute('open')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          }, ms);
        });
      })();
    });
  }

  /* 5. Widget "¿Agregar repuestos?" bajo el botón de compra */
  function initAddon() {
    var tpl = document.getElementById('ap-addon-tpl');
    var info = document.querySelector('.product__info-container');
    if (!tpl || !info || info.__apAddon) return; info.__apAddon = true;
    var form = info.querySelector('.product-form');
    if (!form) return;
    var top = form; while (top && top.parentNode !== info) top = top.parentNode;
    if (!top) return;
    var node = tpl.content.cloneNode(true);
    var root = node.firstElementChild;
    info.insertBefore(node, top.nextSibling);
    var btn = root.querySelector('.ap-addon__btn');
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Agregando…';
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-variant')); fd.append('quantity', '1');
      if (cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status) { throw new Error(state.description || 'error'); }
          btn.textContent = 'Agregado ✓';
          if (cart && cart.renderContents) { cart.renderContents(state); } else { window.location.href = window.routes.cart_url; }
          setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; window.location.href = window.routes.cart_url; });
    });
  }

  function init() { reveal(); carousels(); fixPrices(document.body); initLightbox(); initAddon(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
